"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUserUseCase = void 0;
const users_1 = require("@/services/users");
const users_2 = require("@/store/ducks/users");
const listUsersUseCase_1 = require("./listUsersUseCase");
function createUserUseCase(payload) {
    return async (dispatch) => {
        dispatch((0, users_2.saveChanges)());
        try {
            await (0, users_1.createUser)(payload);
            dispatch((0, users_2.saveChangesSuccess)());
            dispatch((0, users_2.openUserToast)({
                status: "success",
                message: "User created successfylly.",
            }));
            await (0, listUsersUseCase_1.listUsersUseCase)()(dispatch);
            dispatch((0, users_2.closeCreateUserModal)());
        }
        catch (e) {
            dispatch((0, users_2.saveChangesError)());
            dispatch((0, users_2.openUserToast)({
                status: "error",
                message: "Error creating user.",
            }));
        }
    };
}
exports.createUserUseCase = createUserUseCase;
